import actions from 'od-modules/secure_store/actions';
import {dispatch} from 'od-modules/secure_store/store';
import {getMembershipInfo, activateMembershipAutoRenewal} from 'od-modules/secure_store/reducers/asyncActionCreators';

export default Backbone.Model.extend({
    defaults: {
        isReactivateOfferSelected: false,
        isReactivateDecisionTaken: false,
        membershipExpirationDate: '',
    },

    async initializeExpirationDate() {
        const {expirationDate = null} = await this.fetchMembershipInfo();
        this.set('membershipExpirationDate', this.formatDate(expirationDate));
    },

    propagateMembershipProduct() {
        const isReactivateOfferSelected = this.get('isReactivateOfferSelected');
        this.setMembershipProduct(isReactivateOfferSelected);
        isReactivateOfferSelected && this.putAutoRenewalOption();
    },

    setMembershipProduct(isReactivateOfferSelected) {
        dispatch({
            type: actions.SET_MEMBERSHIP_SUBSCRIPTION_OFFER,
            entry: {
                reactivatePrime: isReactivateOfferSelected,
            },
            merge: true,
        });
    },

    async fetchMembershipInfo() {
        return (await getMembershipInfo(dispatch)) || {};
    },

    formatDate(date) {
        return date && new Date(date).toLocaleDateString(navigator.language);
    },

    async putAutoRenewalOption() {
        await activateMembershipAutoRenewal(dispatch);
    },
});
